<template>
  <div class="main_block">
    <div class="order_whole_block">
      <div class="order_header_block" v-if="alerts !== undefined && alerts !== null && alerts.length > 0">
        <div class="order__header-block__item" v-for="(item, index) in alerts" :key="index">
          • {{ item }}
        </div>
      </div>

      <div class="order_block_sec">
        <div class="order_block_sec-1">
          <h2>
            <div class="order_block_sec-1__mobile-open-menu" @click="openOrderList()">
              <img src="@img/arrow-white.svg" alt="">
            </div>
            <!-- ZZZZ -->
            <!-- Исходная ситуация - нарушенные земли -->
            {{ getSelectedReportName() }}
          </h2>
          <div class="button_group_order">
            <button @click="goInterfaceSpecialist()"><i class="fas fa-map i_style"></i> {{ locale === 'en' ? 'On the map' : 'Заказ на карте' }} </button>
            <button @click="setShowReportsList(true)" style="margin-left: 5px"><i class="fa fa-arrow-down i_style"></i> {{ locale === 'en' ? 'Reports' : 'Отчеты' }}</button>
          </div>
        </div>

        <div class="order_block_sec-2">
          <div class="graph_div_list">
            <button @click="changeList('column')" class="button_list" :class="{'button_list__active': viewType === 'column'}" ref="but_list"><img src="@img/column.svg" alt=""></button>
            <button @click="changeList('row')" class="button_list" :class="{'button_list__active': viewType === 'row'}" ref="but_row"><img src="@img/row.svg" alt=""></button>
          </div>
          <div class="chain-wrapper" v-if="showChain">
            <div class="chain-item" @click="changeOrder(selectedOrder, true)">{{ getHumanProductName(selectedOrder) }}</div>
            <div class="chain-item" @click="changeReportFromChain(item)" v-for="(item, index) in chain" :key="index" v-show="item.number !== '' && index !== 0">{{ item.name !== '' ? item.name : item.number }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- <i class="fad fa-border-bottom"></i> -->
    <div ref="graps" :class="viewType === 'column' ? 'graphs_main' : 'graphs_main_row'" v-if="loadingData">
      <div class="graphs shine" v-for="i in 4" :key="i" :style="{'animation-delay': i * 100 + 'ms'}"></div>
    </div>
    <div ref="graps" v-else-if="!loadingData && ordersList.length === 0">
      <div class="no-orders">
        <div class="no-orders__text">
          {{ locale === 'en' ? 'No orders' : 'Заказы отсутствуют' }}
        </div>
        <div class="no-orders__img-wrapper">
          <img src="@img/no-orders.svg" alt="">
        </div>
      </div>
    </div>
    <div ref="graps" :class="viewType === 'column' ? 'graphs_main' : 'graphs_main_row'" v-else>
      <report class="graphs" v-for="(chartData, i) in reportData" :id="i" :key="i" :type="chartData.type" :graphData="chartData.data" :size="chartData.size"/>
    </div>

    <reports-list @setShowReportsList="setShowReportsList($event)" v-if="showReportsList"/>

  </div>
</template>

<script>
import Report from '@/components/main/Report'
import reportsPDFList from '@/components/main/reportsPDFList'

import httpStore from '@storages/httpStore'
import appStore from '@storages/appStore'
import reportStore from '@storages/reportStore'
import adaptiveStore from '@storages/adaptiveStore'
import store from '@storages/store'

export default {
  name: 'main-page',
  components: {
    'report': Report,
    'reports-list': reportsPDFList
  },
  data () {
    return {
      reportData: [],
      activeOrderId: null,
      ordersList: [],
      alerts: [],
      viewType: 'column',
      showReportsList: false
    }
  },
  computed: {
    locale () {
      return appStore.getters.value('locale')
    },
    appName () {
      return appStore.getters.value('name')
    },
    loadingData () {
      return reportStore.getters.value('loadingData')
    },
    chain () {
      return reportStore.getters.value('chain')
    },
    showChain () {
      if (this.chain[1].name === '') {
        return false
      } else {
        return true
      }
    },
    selectedOrder () {
      return reportStore.getters.value('selectedOrder')
    },
    selectedReport () {
      return reportStore.getters.value('selectedReport')
    },
    activeBbox () {
      return reportStore.getters.value('activeBbox')
    },
    loadingOrder () {
      return store.getters.value('loadingOrder')
    },
    products () {
      return appStore.getters.value('products')
    },
    servicesList () {
      let _config = appStore.getters.value('config')
      if ('services' in _config) {
        return _config.services
      }
    }
  },

  async created () {
    let _viewType = this.$cookies.get('viewType')
    this.viewType = _viewType !== null ? _viewType : 'column'
    // this.loadingData = true
    reportStore.dispatch('setValue', {key: 'loadingData', value: true})
    store.dispatch('setValue', {key: 'loadingOrder', value: true})
    await this.getOrdersMix().then(response => {
      this.ordersList = response.body.sort((item1, item2) => { return item1.order_id > item2.order_id ? -1 : 1 })
      // добавление тестового заказа в список. В this.getOrdersMix() надо чтобы заказ с ид 44 обрабатывался по особому
      /* eslint-disable-next-line */
      // this.ordersList.push({"order_id": 44, "product_id": "b_state", "order_number": "TEST-44", "created_at": "2020-04-13T12:30:15.249873", "status": "auto_sources", "owner_id": 10, "capture_date": ["2018-04-01", "2019-09-30"], "total_amount": null, "operator_id": 4, "bbox": {"type": "Polygon", "coordinates": [[[36.3054055863264, 56.6649359678037], [36.3190079740243, 56.6649359678037], [36.3190079740243, 56.6740403075974], [36.3054055863264, 56.6740403075974], [36.3054055863264, 56.6649359678037]]]}, "comment": null, "periodicity": null}) // ZZZZ
      store.dispatch('setValue', {key: 'loadingOrder', value: false})
      store.dispatch('setValue', {key: 'ordersList', value: this.ordersList})
      if ('alert' in response.body && response.body.alert !== null && response.body.alert.length > 0) {
        this.alerts = response.body.alert
      }
      // else {
      //   this.alerts = ['2 заказа готово', '1 в работе', '1 новых', 'Выявлено 5 новых свалок', 'Пожары не обнаружены']
      // }
    }).catch(err => {
      // добавление тестового заказа в список. В this.getOrdersMix() надо чтобы заказ с ид 44 обрабатывался по особому
      /* eslint-disable-next-line */
      // this.ordersList.push({"order_id": 44, "product_id": "b_state", "order_number": "TEST-44", "created_at": "2020-04-13T12:30:15.249873", "status": "auto_sources", "owner_id": 10, "capture_date": ["2018-04-01", "2019-09-30"], "total_amount": null, "operator_id": 4, "bbox": {"type": "Polygon", "coordinates": [[[36.3054055863264, 56.6649359678037], [36.3190079740243, 56.6649359678037], [36.3190079740243, 56.6740403075974], [36.3054055863264, 56.6740403075974], [36.3054055863264, 56.6649359678037]]]}, "comment": null, "periodicity": null}) // ZZZZ
      store.dispatch('setValue', {key: 'ordersList', value: this.ordersList})
      store.dispatch('setValue', {key: 'loadingOrder', value: false})
      console.log('fail get orders', err)
    })

    if (document.body.clientWidth < 425) { // не грузить если мобилка
      // this.loadingData = false
      reportStore.dispatch('setValue', {key: 'loadingData', value: false})
      return
    }

    if (this.$route.params.order_id !== undefined && !isNaN(Number(this.$route.params.order_id))) { // если есть параметр в адресной строке
      let _order = this.ordersList.find(order => { return Number(order.order_id) === Number(this.$route.params.order_id) })
      if (_order !== undefined) {
        this.changeOrder(_order)
        return
      }
    }

    if (this.ordersList.length) { // если никаких параметров нет и пк, просто выбрать первый заказ
      this.changeOrder(this.ordersList[0])
    } else {
      // this.loadingData = false
      reportStore.dispatch('setValue', {key: 'loadingData', value: false})
    }
  },

  mounted () {
    this.$eventHub.$on('getChild', this.getChild)
    this.$eventHub.$on('change-order', this.changeOrder)
  },

  methods: {
    setShowReportsList (val) {
      this.showReportsList = val
    },

    openOrderList () {
      adaptiveStore.dispatch('setValue', {key: 'ordersListOpen', value: true})
    },

    goInterfaceSpecialist () {
      let _service = this.servicesList.find(item => { return item.service_id === this.appName })
      let _url = _service.url + 'orders/' + this.activeOrderId + '/bbox/' + String(this.activeBbox)
      window.open(_url, '_blank')
    },

    getSelectedReportName () {
      if (this.chain[1].name !== '') {
        return this.chain[1].name
      } else {
        return this.getHumanProductName(this.selectedOrder)
      }
    },

    getHumanProductName (selectedOrder) {
      if (selectedOrder === null) {
        return ''
      }
      if (selectedOrder.name !== undefined && selectedOrder.name !== null && selectedOrder.name !== '') {
        return selectedOrder.name
      }
      if (selectedOrder !== null) {
        let productId = selectedOrder.product_id
        if (!Array.isArray(this.products)) {
          return ''
        }
        let _product = this.products.find(item => { return item !== null && item.product_id === productId })
        return _product.product_title
      } else {
        return ''
      }
    },

    changeReportFromChain (item) {
      // this.loadingData = true
      // let _report = reportStore.getters.report({level: item.level, id: item.id})
      // // this.changeOrder()
      // this.reportData.splice(0, this.reportData.length)
      // this.reportData = this.createReportData(_report)
      // reportStore.dispatch('setValue', {key: 'selectedReport', value: _report})
      // reportStore.dispatch('setReportInChain', {level: 1, report: _report})
      // setTimeout(() => { // без этого не происходит destroy компонентов, когда отчет берется из хранилища, и графики не перестраиваются
      //   this.loadingData = false
      // }, 10)
      if (item.level === 1) {
        this.changeOrder(this.selectedOrder)
      }
    },

    getChild (e) {
      // this.loadingData = true
      reportStore.dispatch('setValue', {key: 'loadingData', value: true})
      let _selectedOrder = reportStore.getters.value('selectedOrder')
      // написать ф-ю в миксине для получения дочернего
      let params = {
        orderId: _selectedOrder.order_id,
        dictItemParentId: e.dictItemId,
        dict: this.selectedReport.dict.child
      }
      this.getChildMix(params).then(response => {
        let res = response.body
        res.dict_item_id = e.dictItemId
        reportStore.dispatch('addReport', {report: res, level: 2})
        this.reportData.splice(0, this.reportData.length)
        this.reportData = this.createReportData(res)
        reportStore.dispatch('setValue', {key: 'selectedReport', value: res})
        reportStore.dispatch('setReportInChain', {level: 2, report: res, name: e.name})
        reportStore.dispatch('setValue', {key: 'activeBbox', value: e.bbox})
        // this.loadingData = false
        reportStore.dispatch('setValue', {key: 'loadingData', value: false})
      }, err => {
        console.log('fail get child', err)
        this.changeOrder(this.selectedOrder, true)
      })
    },

    changeList (type) {
      this.viewType = type
      this.$cookies.set('viewType', type)
    },
    downloadReport (reportId) {
      let _url = httpStore.getters.host.replace(this.appName, 'media') + this.appName + '/' + reportId + '.pdf'
      window.open(_url, '_blank')
    },

    changeOrder (order, force) {
      if (force !== true && this.selectedOrder !== null && order.order_id === this.selectedOrder.order_id) {
        return
      }
      // this.loadingData = true
      reportStore.dispatch('setValue', {key: 'loadingData', value: true})
      reportStore.dispatch('setValue', {key: 'selectedOrder', value: order})
      if (order === 'условие которое не выполнится') { // проверка того что этого заказа/отчета нет в хранилище. Если есть, то взять тз хранилища, иначе запросить
      // if (reportStore.getters.hasReport({id: order.order_id, level: 1})) { // проверка того что этого заказа/отчета нет в хранилище. Если есть, то взять тз хранилища, иначе запросить
        let _report = reportStore.getters.report({id: order.order_id, level: 1})
        // console.log(_report)
        this.reportData.splice(0, this.reportData.length)
        this.reportData = this.createReportData(_report)
        this.activeOrderId = order.order_id
        store.dispatch('setValue', {key: 'activeOrderId', value: order.order_id})
        reportStore.dispatch('setValue', {key: 'selectedReport', value: _report})
        reportStore.dispatch('setReportInChain', {level: 1, report: _report})
        reportStore.dispatch('setValue', { key: 'activeBbox', value: this.getBboxFromOrder(order) })
        setTimeout(() => { // без этого не происходит destroy компонентов, когда отчет берется из хранилища, и графики не перестраиваются
          // this.loadingData = false
          reportStore.dispatch('setValue', {key: 'loadingData', value: false})
        }, 10)
      } else {
        this.getOrderByIdMix(order.order_id).then(response => {
          reportStore.dispatch('addReport', {report: response.body, level: 1})
          this.reportData.splice(0, this.reportData.length)
          this.reportData = this.createReportData(response.body)
          this.activeOrderId = order.order_id
          store.dispatch('setValue', {key: 'activeOrderId', value: order.order_id})
          reportStore.dispatch('setValue', {key: 'selectedReport', value: response.body})
          reportStore.dispatch('setReportInChain', {level: 1, report: response.body})
          reportStore.dispatch('setValue', { key: 'activeBbox', value: this.getBboxFromOrder(order) })
          // this.loadingData = false
          reportStore.dispatch('setValue', {key: 'loadingData', value: false})
          // let _viewType = this.$cookies.get('viewType')
          // if (_viewType !== null && _viewType !== 'column' && _viewType !== this.viewType) {
          //   this.changeList('row')
          // }
        }).catch(err => {
          this.reportData.splice(0, this.reportData.length)
          this.activeOrderId = order.order_id
          store.dispatch('setValue', {key: 'activeOrderId', value: order.order_id})
          reportStore.dispatch('setValue', {key: 'selectedReport', value: null})
          reportStore.dispatch('setValue', { key: 'activeBbox', value: [] })
          if (err.status === 404) {
            // this.loadingData = false
            reportStore.dispatch('setValue', {key: 'loadingData', value: false})
          }
          console.log('fail load current order', err)
        })
      }
    },

    getBboxFromOrder (order) {
      if ('bbox' in order && 'coordinates' in order.bbox && order.bbox.coordinates[0] !== undefined) {
        return this.getBboxFromPolygonMix(order.bbox.coordinates[0])
      } else {
        return []
      }
    },

    createReportData (response) {
      if ('charts' in response) {
        let _orderData = []
        for (let chartIndex = 0; chartIndex < response.charts.length; chartIndex++) {
          _orderData.push({
            data: response.charts[chartIndex],
            type: response.charts[chartIndex].type,
            size: this.selectChartSize(response.charts[chartIndex].type)
          })
        }
        return _orderData
      }
    },

    selectChartSize (type) {
      switch (type) {
        case 'bar_chart': case 'bar':
          return 'horizontal-bar'

        case 'table_chart': case 'table':
          return 'table'

        default:
          return 'small'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/varibles.scss';
.no-orders {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.no-orders__text {
  color: #e9e9e9;
  font-size: 29px;
  font-weight: bold;
}
.no-orders__img-wrapper {
  width: 41px;
  height: 41px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 14px;
}
.no-orders__img-wrapper img {
  width: 100%;
  height: 100%;
}
.chain-wrapper {
  // margin-left: 5px;
  display: flex;
  flex-wrap: wrap;
}
.chain-item {
  margin-right: 10px;
  font-size: 18px;
  color: #616161;
}
.chain-item:hover {
  cursor: pointer;
  text-decoration: underline;
}
.chain-item:last-child::after {
  display: none;
}
.chain-item::after {
  display: inline-block;
  content: '>';
  margin-left: 10px;
}
.chain-item:last-child:not(:first-child) {
  color: #b5b4b4;
}
.button_group_order i {
  color: #455c88;
  margin-right: 3px;
  font-size: 12px;
}

.order_whole_block {
  // padding-right: 33px; // 40px отступ сдева и минус 7px скролл
  border-radius: 3px;
}
.button_group_order {
  font-size: 12px;
  display: flex;
  flex-wrap: nowrap;
  // width: 100%;
  margin-bottom: 25px;
  // justify-content: flex-end;
}
.button_group_order button {
  height: 32px;
  // width: 130px;
  padding-left: 15px;
  padding-right: 15px;
  background-color: #dfeafc;
}
.order_block_sec {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  margin-top: 34px;
}
.order_block_sec-1 {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.order_block_sec-2 {
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
}

.order_block_sec-1 h2 {
  color: #383838;
  font-weight: 900;
  font-size: 24px;
  align-self:stretch;
  height: auto;
  margin-bottom: 14px;
}
.order_block_sec-1__mobile-open-menu {
  display: none;
}
.order_block_sec button {
  border: none;
  outline: none;
  color: black;
  border-radius: 10px;
}
.graph_div_list {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
}
.graph_div_list button {
  margin-left: 5px;
  border-radius: 5px;
}
.button_list {
  border: none;
  background: #dfeafc;
  border-radius: 7px;
  width: 32px;
  height: 32px;
  margin-top: -3px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.button_list__active {
  background-color: #e2e2e2;
}
.main_block {
  position: relative;
  padding: 39px 93px 67px 95px;
  background-color: #f8f8f8;
  height: calc(100vh - 180px);
  overflow-y: auto;
  width: 100%;
  transition: .3s;
}
.main_header {
  display: flex;
  padding: 27px 24px 10px 24px;
  overflow: auto;
}
.report {
  margin-right: 8px;
  color: #717171;
  background-color: #f1f1f1;
  min-width: 62px;
  // max-width: 150px;
  border-radius: 10px;
  cursor: pointer;
  padding: 13px 27px;
  box-shadow: $Shadow;
}
.report:hover {
  background-color: #e7e7e7;
}
.report-loading {
  background-color: #dbd8d854;
  color: rgb(66, 66, 66);
}
.report-name {
  width: 100%;
  height: 100%;
  text-align: center;
  font-size: 16px;
}
.active-report {
  background-color: #dfeafc;
  color: #455c88;
}
.active-report:hover {
  background-color: rgba(49, 111, 234, 0.3);
  color: #455c88;
}
.graphs_main {
  // display: flex;
  // flex-wrap: wrap;
  // flex-direction: row;
  // justify-content: space-between;
  padding: 8px 0; // сверху/снизу - с макета, справа - 40px минус 7px скролл
  min-height: calc(100vh - 170px);
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  grid-column-gap: 43px;
}
.graphs_main_row {
  // display: flex;
  // flex-wrap: wrap;
  // flex-direction: row;
  // justify-content: space-between;
  padding: 8px 0 20px 0;
  min-height: calc(100vh - 170px);
  grid-template-columns: 100%;
  display: grid;
  grid-column-gap: 43px;
}
.graphs {
  // width: calc(33% - 68px);
  // width: 342px;
  height: $Height-report-small-graph + $Height-report-small-title;
  // padding: 33px 34px 34px 34px;
  margin-top: 10px;
  // margin-left: -43px;
  // margin-right: 86px;
  margin-bottom: 40px;
  box-shadow: $Shadow;
  // cursor: pointer;
  border-radius: 5px;
  background-color: white;
}
.loading-wrapper {
  width: 100%;
  background-color: #dbd8d854;
}
@media (max-width: 800px) {
  .main_block {
    margin-top: 0;
    padding-top: 0;
  }
  .main_header {
    padding: 10px;
  }
  .report {
    min-width: 90px;
    font-size: 14px;
    padding: 10px 5px;
    // height: 35px;
  }
  .graphs_main {
    flex-direction: column;
    align-items: center;
    padding: 8px 0;
    min-height: unset;
  }
}
.second_block {
  display: flex;
  flex-direction: column;
}
.second_block span {
  margin-bottom: 5px;
}
.first_block {
}
.span_fire {
  color: #cb302d;
}
.divide_block {
  width: 1px;
  height: 100%;
  background-color: #ffdbd8;
}
.order_header_block {
  display: flex;
  border-radius: 10px;
  align-items: center;
  // justify-content: space-around;
  flex-wrap: wrap;
  background-color: #ffe9e7;
  // height: 120px;
  padding: 40px 30px 50px;
  width: calc(100% - 60px);
}
.order__header-block__item {
  margin-right: 25px;
  margin-top: 10px;
}
@media (min-width: 768px) and (max-width: 960px) {
  .main_block {
    padding-bottom: 116px;
    padding-left: 40px;
    padding-right: 30px;
  }
}
@media (min-width: 426px) and (max-width: 768px) {
  .main_block {
    padding-right: 40px;
    padding-left: 40px;
    padding-bottom: 116px;
  }

  .graphs {
    width: 100%;
    height: $Height-report-small__mobile;
    margin: 10px 0;
    padding: 0;
  }

  .graphs_main_row {
    display: block;
  }

  .order_block_sec {
    margin-top: 22px;
  }
}

@media (min-width: 320px) and (max-width: 425px) {
  .main_block {
    padding-right: 15px;
    padding-left: 15px;
    // height: calc(100vh - 67px); // padding x2 + scroll(7px)
    height: unset;
  }
  .button_group_order {
    // width: 220px;
    width: 100%;
    justify-content: space-between;
    // flex-direction: row;
    margin-bottom: 9px;
  }

  .button_group_order button {
    width: 48%;
    margin-bottom: 0;
    margin-left: 0 !important;
  }
  .graph_div_list {
    display: none;
  }
  .order_block_sec-1 {
    justify-content: flex-start;
    align-items: center;
  }
  .order_block_sec-1 h2 {
    font-size: 20px;
    // line-height: 22px;
    padding-right: 44px;
    display: flex;
  }
  .order_block_sec-1__mobile-open-menu {
    flex: none;
    display: flex;
    // float: left;
    width: 42px;
    height: 42px;
    background-color: #2d325a;
    border-radius: 50%!important;
    color: white!important;
    padding: 0;
    justify-content: center;
    align-items: center;
    margin-right: 14px;
  }
  .order_block_sec-1__mobile-open-menu img {
    height: 18px;
  }
  .graphs {
    width: 100%;
    height: $Height-report-small__mobile;
    margin: 10px 0;
    padding: 0;
  }
  .graphs_main {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    padding-left: 0;
    padding-right: 0;
  }
  .order_block_sec {
    margin-top: 22px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/main/Main.vue